export enum RandomizationPattern {
    None,
    Permutation,
    Rotation,
    ReverseOrder,
    Synchronized,
    SortByCode,
    SortByLabel,
    RandomReverse,
}
